import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from './stores/auth.store';
import { LoadingScreen } from './components/LoadingScreen';
import { OnboardingPage } from './pages/OnboardingPage';
import { PendingPage } from './pages/PendingPage';
import { HomePage } from './pages/HomePage';
import { DutyStartPage } from './pages/DutyStartPage';
import { DutyActivePage } from './pages/DutyActivePage';
import { HistoryPage } from './pages/HistoryPage';
import { DutyDetailPage } from './pages/DutyDetailPage';
import { ProfilePage } from './pages/ProfilePage';
import { SupervisorDutyLogsPage } from './pages/SupervisorDutyLogsPage';
import { SupervisorOfficersPage } from './pages/SupervisorOfficersPage';
import { SupervisorDashboardPage } from './pages/SupervisorDashboardPage';

export default function App() {
  const { ready, officer, error, bootstrap } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  // route gating ตาม status
  useEffect(() => {
    if (!ready || !officer) return;
    const hasProfile = officer.firstName && officer.lastName;
    if (officer.status === 'pending' && !hasProfile) {
      navigate('/onboarding', { replace: true });
    } else if (officer.status === 'pending') {
      navigate('/pending', { replace: true });
    }
    // active: ปล่อยให้อยู่หน้าที่กำลังอยู่
  }, [ready, officer?.status, officer?.firstName, navigate]);

  if (!ready) return <LoadingScreen text="กำลังเข้าสู่ระบบผ่าน LINE..." />;
  if (error) {
    return (
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center bg-white p-6 text-center">
        <div className="text-5xl">⚠️</div>
        <h1 className="mt-3 text-xl font-bold">เข้าสู่ระบบไม่สำเร็จ</h1>
        <p className="mt-2 text-sm text-gray-600">{error}</p>
        <button onClick={() => location.reload()} className="btn-secondary mt-6">
          ลองใหม่
        </button>
      </div>
    );
  }
  if (!officer) return <LoadingScreen />;
  if (officer.status === 'suspended') {
    return (
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center bg-white p-6 text-center">
        <div className="text-5xl">🚫</div>
        <h1 className="mt-3 text-xl font-bold">บัญชีถูกระงับ</h1>
        <p className="mt-2 text-sm text-gray-600">กรุณาติดต่อเจ้าหน้าที่ฝ่ายธุรการ</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/pending" element={<PendingPage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/duty/start" element={<DutyStartPage />} />
      <Route path="/duty/active" element={<DutyActivePage />} />
      <Route path="/duty/:id" element={<DutyDetailPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/supervisor/duty-logs" element={<SupervisorDutyLogsPage />} />
      <Route path="/supervisor/officers" element={<SupervisorOfficersPage />} />
      <Route path="/supervisor/dashboard" element={<SupervisorDashboardPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
